// extracted by mini-css-extract-plugin
export default {"imgContainer":"style_imgContainer__hA2V5","uploadPicture":"style_uploadPicture__zMS2V","uploadIcon":"style_uploadIcon__xOGHF"};